import React from "react";
import Input from "../Input/Input";

const TimePicker = ({ ...props }) => {
  return <Input type="time" {...props} />;
};

export { TimePicker };
